import { render, staticRenderFns } from "./IntegrationFormWebhook.vue?vue&type=template&id=875f9128&scoped=true"
import script from "./IntegrationFormWebhook.vue?vue&type=script&lang=js"
export * from "./IntegrationFormWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875f9128",
  null
  
)

export default component.exports